import { jsx as o } from "react/jsx-runtime";
import * as m from "react";
import { forwardRef as r } from "react";
import { u as n, S as s, _ as i } from "../../Select-ef7c0426.esm-CLLMzlZJ.js";
import "../../index-CJ0TdoNN.js";
import { styles as c } from "./theme.js";
var d = /* @__PURE__ */ r(function(e, t) {
  var a = n(e);
  return /* @__PURE__ */ m.createElement(s, i({
    ref: t
  }, a));
}), f = d;
const l = r(
  (e, t) => /* @__PURE__ */ o(f, { ...e, styles: c, menuPortalTarget: typeof document < "u" ? document.body : void 0, menuPosition: "fixed", ref: t })
);
l.displayName = "Select";
export {
  l as Select
};
